<template>
  <div :class="getClass()" @click="showModal = true">
    <svg
      alt="Share icon"
      class="share-button__icon"
      width="36"
      height="40"
      viewBox="0 0 36 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.8667 31.3717L11.8684 24.555C10.9547 25.5318 9.76833 26.2112 8.46347 26.5048C7.15862 26.7985 5.7956 26.6929 4.55155 26.2017C3.30751 25.7106 2.23995 24.8566 1.48763 23.7508C0.73531 22.6449 0.333008 21.3383 0.333008 20.0008C0.333008 18.6634 0.73531 17.3568 1.48763 16.2509C2.23995 15.1451 3.30751 14.2911 4.55155 13.7999C5.7956 13.3088 7.15862 13.2032 8.46347 13.4969C9.76833 13.7905 10.9547 14.4699 11.8684 15.4467L22.8684 8.63001C22.4709 7.0568 22.6609 5.39266 23.4027 3.94952C24.1445 2.50638 25.3872 1.38332 26.8978 0.790849C28.4084 0.198383 30.0832 0.177188 31.6083 0.731238C33.1334 1.28529 34.4041 2.37654 35.1822 3.80045C35.9603 5.22436 36.1923 6.88316 35.8349 8.46592C35.4774 10.0487 34.5549 11.4467 33.2404 12.398C31.9259 13.3493 30.3095 13.7885 28.6944 13.6333C27.0792 13.4781 25.576 12.7392 24.4667 11.555L13.4667 18.3717C13.7354 19.4406 13.7354 20.5594 13.4667 21.6283L24.465 28.445C25.5744 27.2608 27.0775 26.5219 28.6927 26.3667C30.3079 26.2115 31.9242 26.6507 33.2387 27.602C34.5533 28.5533 35.4757 29.9513 35.8332 31.5341C36.1907 33.1169 35.9586 34.7757 35.1805 36.1996C34.4024 37.6235 33.1318 38.7147 31.6067 39.2688C30.0815 39.8228 28.4067 39.8016 26.8961 39.2092C25.3855 38.6167 24.1429 37.4937 23.4011 36.0505C22.6593 34.6074 22.4693 32.9432 22.8667 31.37V31.3717ZM7.00002 23.3333C7.88407 23.3333 8.73192 22.9822 9.35704 22.357C9.98216 21.7319 10.3334 20.8841 10.3334 20C10.3334 19.116 9.98216 18.2681 9.35704 17.643C8.73192 17.0179 7.88407 16.6667 7.00002 16.6667C6.11596 16.6667 5.26812 17.0179 4.64299 17.643C4.01787 18.2681 3.66668 19.116 3.66668 20C3.66668 20.8841 4.01787 21.7319 4.64299 22.357C5.26812 22.9822 6.11596 23.3333 7.00002 23.3333ZM29.3334 10.3333C30.2174 10.3333 31.0653 9.98216 31.6904 9.35704C32.3155 8.73192 32.6667 7.88407 32.6667 7.00001C32.6667 6.11596 32.3155 5.26811 31.6904 4.64299C31.0653 4.01787 30.2174 3.66668 29.3334 3.66668C28.4493 3.66668 27.6014 4.01787 26.9763 4.64299C26.3512 5.26811 26 6.11596 26 7.00001C26 7.88407 26.3512 8.73192 26.9763 9.35704C27.6014 9.98216 28.4493 10.3333 29.3334 10.3333ZM29.3334 36.3333C30.2174 36.3333 31.0653 35.9822 31.6904 35.357C32.3155 34.7319 32.6667 33.8841 32.6667 33C32.6667 32.116 32.3155 31.2681 31.6904 30.643C31.0653 30.0179 30.2174 29.6667 29.3334 29.6667C28.4493 29.6667 27.6014 30.0179 26.9763 30.643C26.3512 31.2681 26 32.116 26 33C26 33.8841 26.3512 34.7319 26.9763 35.357C27.6014 35.9822 28.4493 36.3333 29.3334 36.3333Z"
      />
    </svg>
  </div>
  <Teleport to="body">
    <ShareModal
      :modalTitle="miscText.shareTestTitle"
      v-show="showModal"
      @closeModal="showModal = false"
      :urlToShare="getQuizUrl"
      :kakaoShareInfo="kakaoShareInfo"
    >
      {{ miscText.shareTestDesc }}
    </ShareModal>
  </Teleport>
</template>
<script>
import { ref, Teleport, computed } from "vue";
import ShareModal from "./ShareModal.vue";
import { useGetters } from "vuex-composition-helpers";

export default {
  name: "a-modal",
  components: { Teleport, ShareModal },
  props: {
    white: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const showModal = ref(false);

    const { miscText, ogTags, currentLang } = useGetters([
      "miscText",
      "ogTags",
      "currentLang",
    ]);

    const getClass = function () {
      const classes = ["share-button"];
      if (props.white) classes.push("red-icon");
      return classes.join(" ");
    };

    const getQuizUrl = computed(() => {
      const currentUrl = window.location.origin;

      let url = "https://eoy.2022.asiance-dev-02.com";

      if (currentUrl.includes(":8080")) return `${url}/${currentLang.value}`;
      return `${window.location.origin}/${currentLang.value}`;
    });

    const kakaoOGImage = computed(() => {
      const kakaoimg = require(`@/assets/share-imgs/kakao-website-${currentLang.value}.png`);
      return kakaoimg;
    });

    const kakaoShareInfo = computed(() => {
      return {
        title: ogTags.value.homePage.ogTitle,
        description: ogTags.value.homePage.ogDescription,
        imageUrl: `${getQuizUrl.value.slice(0, -3)}${kakaoOGImage.value}`,
      };
    });

    return {
      kakaoOGImage,
      miscText,
      getQuizUrl,
      showModal,
      getClass,
      kakaoShareInfo,
    };
  },
};
</script>

<style lang="scss">
.share-button {
  background: $red;
  display: flex;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1;
  min-height: get-vw(80px);
  height: 100%;
  cursor: url("@/assets/cursor.png"), pointer;
  &__icon {
    fill: white;
    height: get-vw(29px);
    fill: white;
  }

  @include media-breakpoint-down(lg) {
    width: 56px;
    height: 56px;
    &__icon {
      height: 19px;
    }
  }

  &.red-icon {
    background: white;

    .share-button__icon {
      fill: $red;
    }
  }
}
</style>
